import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const EeFiAif = () => {
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    document.title = 'EE-Fi AIF - Category II Alternative Investment Fund | Elevar Equity';
  }, []);

  const aifData = {
    name: 'EE-Fi AIF',
    schemeName: 'EE-Fi AIF',
    category: 'Category II',
    sebiRegistration: 'IN/AIF2/21-22/0927',
    registrationDate: '02-Sep-2021',
    fundManager: 'Elevar Venture Partners LLP',
    registeredAddress: '10th Floor Prestige Summit, No 6 St. John\'s Road, Sivanchetti Garden, Ulsoor, Bengaluru – 560042, Karnataka',
    gstn: '29AABTE1526A1Z9',
    legalEntityIdentifier: '335800TXSFIPFRHPQ230',
    trustee: 'Vistra ITCL (India) Limited',
    complianceOfficer: 'Shobha Venkataraman',
    scoresId: 'AIF00818',
    contactEmail: 'cco@elevarequity.com'
  };

  return (
    <div className="scheme-container">
      {/* Skip to main content link */}
      <a href="#main-content" className="skip-to-main">
        Skip to main content
      </a>

      {/* Animated Background */}
      <div className="animated-background" aria-hidden="true">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
        <div className="grid-overlay"></div>
      </div>

      {/* Main Content */}
      <div className="scheme-content-wrapper">
        {/* Back Button */}
        <Link to="/" className="back-button" aria-label="Navigate back to home page">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          <span>Back to Home</span>
        </Link>

        {/* Header Section */}
        <header className="scheme-header">
          <div className="scheme-badge">Category II AIF</div>
          <h1 className="scheme-title">{aifData.name}</h1>
          <h2 className="scheme-subtitle">Alternative Investment Fund - {aifData.category}</h2>
        </header>

        <main id="main-content">
          {/* Info Cards Grid */}
          <div className="info-cards-grid">
            {/* SEBI Registration Card */}
            <div className="info-card">
              <div className="info-card-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <div className="info-card-content">
                <h3 className="info-card-title">SEBI Registration Number</h3>
                <p className="sebi-reg-number">{aifData.sebiRegistration}</p>
                <p className="info-card-description">Date of Registration: {aifData.registrationDate}</p>
              </div>
            </div>

            {/* Fund Manager Card */}
            <div className="info-card">
              <div className="info-card-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
              </div>
              <div className="info-card-content">
                <h3 className="info-card-title">Investment Manager</h3>
                <p className="info-card-value">{aifData.fundManager}</p>
              </div>
            </div>

            {/* Trustee Card */}
            <div className="info-card">
              <div className="info-card-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                  <path d="M2 17l10 5 10-5"/>
                  <path d="M2 12l10 5 10-5"/>
                </svg>
              </div>
              <div className="info-card-content">
                <h3 className="info-card-title">Trustee</h3>
                <p className="info-card-value">{aifData.trustee}</p>
              </div>
            </div>

            {/* GSTN Card */}
            <div className="info-card">
              <div className="info-card-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
              </div>
              <div className="info-card-content">
                <h3 className="info-card-title">GSTN</h3>
                <p className="info-card-value">{aifData.gstn}</p>
              </div>
            </div>

            {/* Legal Entity Identifier Card */}
            <div className="info-card">
              <div className="info-card-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
              </div>
              <div className="info-card-content">
                <h3 className="info-card-title">Legal Entity Identifier</h3>
                <p className="info-card-value lei-value">{aifData.legalEntityIdentifier}</p>
              </div>
            </div>

            {/* Compliance Officer Card */}
            <div className="info-card">
              <div className="info-card-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </div>
              <div className="info-card-content">
                <h3 className="info-card-title">Compliance Officer</h3>
                <p className="info-card-value">{aifData.complianceOfficer}</p>
              </div>
            </div>

            {/* SCORES ID Card */}
            <div className="info-card">
              <div className="info-card-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                </svg>
              </div>
              <div className="info-card-content">
                <h3 className="info-card-title">SCORES ID</h3>
                <p className="info-card-value">{aifData.scoresId}</p>
              </div>
            </div>
          </div>

          {/* Registered Address Section */}
          <div className="address-section">
            <div className="address-card">
              <div className="address-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
              </div>
              <div className="address-content">
                <h3 className="address-title">Registered Address</h3>
                <p className="address-text">{aifData.registeredAddress}</p>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="scheme-contact-section">
            <h2 className="scheme-contact-title">Contact</h2>
            <div className="scheme-contact-info">
              <p className="scheme-contact-label">Compliance officer</p>
              <a 
                href={`mailto:${aifData.contactEmail}`}
                className="scheme-contact-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Email Compliance Officer at ${aifData.contactEmail}`}
              >
                <div className="scheme-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <span>{aifData.contactEmail}</span>
              </a>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="scheme-footer">
          <p>©{currentYear} Elevar Equity. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default EeFiAif;
